import React from "react"
import { HashRouter as Router, Routes, Route } from "react-router-dom"
import Login from "./UI/Admin/Pages/Login/Login.js"
import PrivateRoute from "./UI/Admin/protecter/protecterRoute"

//Dashboard
import Admin from "./UI/Admin/Admin"
import About from "./UI/Admin/Pages/About/About.jsx"
import ResetPassword from "./UI/Admin/Pages/ResetPassword/ResetPassWord.jsx"

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/resetPassword/:token" element={<ResetPassword />}></Route>
          {/* <Route exact path="/about" element={<About />} /> */}
          <Route exact path="/" element={<Login />} />
          <Route
            exact
            path="/admin/*"
            element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            }
          />
          <Route exact path="*" element={<Login />} />
        </Routes>
      </Router>
    </>
  )
}

export default App
